function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { text120, spacing4 } from "@churchofjesuschrist/eden-style-constants";
import { Text5 } from "@churchofjesuschrist/eden-text";
const PrimaryMetaStyled = styled(_ref => {
  let { ...props
  } = _ref;
  delete props.removeMargin;
  delete props.isFlex;
  delete props.noTheme;
  return /*#__PURE__*/React.createElement(Text5, props);
}).withConfig({
  componentId: "sc-kvhaqt-0"
})(["", " ", ";width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;", ""], _ref2 => {
  let {
    noTheme
  } = _ref2;
  return noTheme ? "" : css(["color:", ";"], _ref3 => {
    let {
      theme
    } = _ref3;
    return theme.primaryColor ? theme.primaryColor : text120;
  });
}, _ref4 => {
  let {
    isFlex
  } = _ref4;
  return isFlex ? "display: flex" : "";
}, _ref5 => {
  let {
    removeMargin
  } = _ref5;
  return removeMargin ? "" : `margin-bottom: ${spacing4};`;
});
/** Defaults are set to vertical tile specs options are for horizontal ones to use */

const PrimaryMeta = _ref6 => {
  let {
    removeMargin = false,
    noTheme = false,
    isFlex = false,
    children,
    ...props
  } = _ref6;
  delete props.theme;
  return /*#__PURE__*/React.createElement(PrimaryMetaStyled, _extends({
    removeMargin,
    isFlex,
    noTheme
  }, props), children);
};

PrimaryMeta.propTypes = {
  /** Meta contents */
  children: PropTypes.node.isRequired,

  /** Whether to apply the theme color or not */
  noTheme: PropTypes.bool,

  /** Whether to apply flex styles or not*/
  isFlex: PropTypes.bool,

  /** Remove the margin-bottom */
  removeMargin: PropTypes.bool,

  /** Theme color for text */
  theme: PropTypes.shape({
    primaryColor: PropTypes.string
  })
};
export default PrimaryMeta;